export type EventMappings = Record<string, Record<string, string>>;

export type AnalyticsProvider = {
  name: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  track: (eventName: string, properties?: Record<string, any>) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  forceTrack?: (eventName: string, properties?: Record<string, any>) => Promise<void>;
  setUserId?: (userId: string) => void;
  reset?: () => void;
};

export default class Analytics {
  private providers: AnalyticsProvider[] = [];

  private eventMappings: EventMappings = {};

  addProvider(provider: AnalyticsProvider): void {
    this.providers.push(provider);
  }

  mapEvent(eventName: string, mappings: Record<string, string>): void {
    this.eventMappings[eventName] = mappings;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async track(eventName: string, properties: Record<string, any> = {}): Promise<void> {
    for (const provider of this.providers) {
      const mappedEvent = this.eventMappings[eventName]?.[provider.name];

      if (!mappedEvent) {
        continue;
      }

      await provider.track(mappedEvent, properties);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async forceTrack(eventName: string, properties: Record<string, any> = {}): Promise<void> {
    for (const provider of this.providers) {
      const mappedEvent = this.eventMappings[eventName]?.[provider.name];

      if (!mappedEvent || !provider.forceTrack) {
        continue;
      }

      await provider.forceTrack(mappedEvent, properties);
    }
  }

  setUserId(userId: string): void {
    for (const provider of this.providers) {
      provider.setUserId?.(userId);
    }
  }

  reset(): void {
    for (const provider of this.providers) {
      provider.reset?.();
    }
  }
}
